import { GetPaymentResultDTO } from '../@types/GetPaymentResultDTO';
import { useQuery } from '@tanstack/react-query';
import { getPayment } from './payments-api';
import { useFetchPerson } from '../person-api';
import { Person } from '../@types/GetPersonDTO'
import { getFuturePaymentsAfterDate } from '../../data/selectors/payment-selector';

const SCOPE = 'list';
const ENTITY = 'closest-payments';

const KeyFactory = {
  closestPayments: (numPayments: number, loanId: string) => [SCOPE, ENTITY, { numPayments, loanId }],
};

const getClosestPayments = async (
  numPayments: number,
  loanId: string,
  date: string,
  personData: Person
): Promise<GetPaymentResultDTO[]> => {
  const loanIdToUse = loanId || String(personData.loans[0].id);

  const payments = await getPayment(loanIdToUse);
  return getFuturePaymentsAfterDate(payments, date, numPayments);
};

export const useClosestPayments = (
  numPayments: number,
  loanId: string,
  date: string
): [GetPaymentResultDTO[] | undefined, boolean] => {
  const [personData, isLoadingPerson] = useFetchPerson();

  const queryKey = KeyFactory.closestPayments(numPayments, loanId);
  const queryFn = () => personData ? getClosestPayments(numPayments, loanId, date, personData) : Promise.resolve([]);

  const { data, isLoading: isLoadingPayments } = useQuery({
    queryKey,
    queryFn,
    enabled: !!numPayments && !!date && !isLoadingPerson && personData !== null,
  });

  return [data, isLoadingPerson || isLoadingPayments];
};
